export enum NbaConditionResolverId {
  IsSimilarStockCarsAvailable = 'isSimilarStockCarsAvailable',
  IsSimilarStockCarsAvailableAtAll = 'isSimilarStockCarsAvailableAtAll',
  IsBmFour = 'isBmFour',
  IsSalesTouchSourceParameterAvailable = 'isSalesTouchSourceParameterAvailable',
  IsSalesTouchSourceParameterNotAvailable = 'isSalesTouchSourceParameterNotAvailable',
  IsInIntegratedMode = 'isInIntegratedMode',
  IsInStandaloneMode = 'isInStandaloneMode',
  IsTestdriveAvailable = 'isTestdriveAvailable',
  IsMobile = 'isMobile',
  IsDesktop = 'isDesktop',
  IsMonthlyRateCalculated = 'isMonthlyRateCalculated',
  IsFcisInitialized = 'isFcisInitialized',
  IsSummary = 'isSummary',
  IsNotSummary = 'isNotSummary'
}
